import api from './api';

const ContatoService = {
  index: (params = {}) => {
    return api.get('/contato', { params });
  },
  show: (id) => {
    return api.get(`/contato/${id}`);
  },
  store: (contato) => {
    return api.post('/contato', contato);
  },
  update: (id, contato) => {
    return api.put(`/contato/${id}`, contato);
  },
  destroy: (id) => {
    return api.delete(`/contato/${id}`);
  }, 
  destroyEmMassa: (ids) => {
    return api.post('/contato/remover-em-massa', { ids });
  },
  toggleAtivo: (id, ativo) => {
    return api.put(`/contato/${id}/ativo`, { ativo });
  },
  metricas: () => {
    return api.get('/contato/metricas');
  },
};

export default ContatoService;

